import React from 'react';
import MaterialLink from '@mui/material/Link';
import { NavLink } from 'react-router-dom';
import { NavigationItemType } from 'framework/navigation';
import NavigationItemLabel from 'framework/ui/menu/NavigationItemLabel';
import GroupedHeaderMenuItem from './GroupedHeaderMenuItem';
import { isHeaderMenuItemActive } from '../utils/headerMenuMatching';

const HeaderMenuTab = ({ item, pathname }: { item: NavigationItemType; pathname: string }) => {
  const { name, url, exact = false, isAlpha, isBeta } = item;

  return (
    <div className="header-menu__item" id={url}>
      {item.thirdLevelMenuChildren ? (
        <GroupedHeaderMenuItem item={item} pathname={pathname} />
      ) : (
        <NavLink to={url} end={exact}>
          <MaterialLink
            component="span"
            data-text={name || url}
            data-testid={`desktop-menu-item-${name || url}`}
            className={`header-menu__item-link ${isHeaderMenuItemActive(item, pathname) ? 'active' : ''}`}
          >
            <NavigationItemLabel name={name || url} url={url} isAlpha={isAlpha} isBeta={isBeta} />
          </MaterialLink>
        </NavLink>
      )}
    </div>
  );
};

export default HeaderMenuTab;
